import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Divider } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { UsLegalStatus } from '../utils/constants';
import type { UsLegalStatus as UsLegalStatusType } from '../utils/types';
import { CitizenshipFields } from './citizenship-fields';
import { CountryOfBirthField } from './country-of-birth-field';
import { StatusFields } from './status-fields';
import { VisaFields } from './visa-fields';
type UsLegalStatusFieldsProps = {
  locale?: Locale;
  onStatusChange: (newStatus: UsLegalStatusType) => void;
  disabledDis: DataIdentifier[];
};
export const UsLegalStatusFields = t0 => {
  const $ = _c(28);
  const {
    locale,
    onStatusChange,
    disabledDis
  } = t0;
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = diToFormData("id.us_legal_status");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== control) {
    t2 = {
      control,
      name: t1
    };
    $[1] = control;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedLegalStatus = useWatch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex gap-1 items-center"><IcoBuilding24 color="primary" /><span className="text-label-2 text-primary">Legal status</span></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== disabledDis) {
    t4 = disabledDis.includes("id.us_legal_status");
    $[4] = disabledDis;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onStatusChange || $[7] !== t4) {
    t5 = <StatusFields onStatusChange={onStatusChange} disabled={t4} />;
    $[6] = onStatusChange;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = locale ?? "en-US";
  let t8;
  if ($[10] !== disabledDis) {
    t8 = disabledDis.includes("id.nationality");
    $[10] = disabledDis;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <CountryOfBirthField locale={t7} disabled={t8} />;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== disabledDis || $[16] !== locale || $[17] !== selectedLegalStatus) {
    t10 = selectedLegalStatus && selectedLegalStatus !== UsLegalStatus.citizen && <CitizenshipFields locale={locale ?? "en-US"} disabled={disabledDis.includes("id.citizenships")} />;
    $[15] = disabledDis;
    $[16] = locale;
    $[17] = selectedLegalStatus;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== disabledDis || $[20] !== locale || $[21] !== selectedLegalStatus) {
    t11 = selectedLegalStatus === UsLegalStatus.visa && <VisaFields locale={locale} disabledDis={disabledDis} />;
    $[19] = disabledDis;
    $[20] = locale;
    $[21] = selectedLegalStatus;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t5 || $[26] !== t9) {
    t12 = <div className="flex flex-col gap-4">{t3}{t5}{t6}{t9}{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t5;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};